import IntersectableObject from "./IntersectableObject"
export default class Button extends IntersectableObject {
    constructor(controls) {
        super()
        this.controls = controls

        this.addBindings()
        this.addEventListeners()
    }

    addBindings() {
        this.onClick = this.onClick.bind(this)
    }

    addEventListeners() {
        this.controls.addEventListener('selectStart', this.onClick)
    }

    removeEventListeners() {
        this.controls.removeEventListener('selectStart', this.onClick)
    }

    onClick(event) {
        const evt = event.data
        const intersecting = this.checkForIntersects(evt)

        if (intersecting) {
            this.dispatchEvent({ type: 'click' })
            this.click()
        }
    }

    click() {

    }
}